import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";
import ProjectCalculatorForm from "./ProjectCalculatorForm";

const ProjectBudgetCalculator = ({
  inputs: initialInputs,
  editing,
  defaultBillingRate = null,
  showMonthlyHours,
  setState
}) => {
  const [inputs, setInputs] = useState(initialInputs || {});
  const [lastUpdatedInput, setLastUpdatedInput] = useState();

  const calculatedHours = useMemo(
    () =>
      inputs?.budget_amount &&
      inputs?.rate &&
      (inputs?.budget_amount / inputs?.rate).toFixed(2),
    [inputs.budget_amount, inputs.rate]
  );

  const calculatedAmount = useMemo(
    () =>
      inputs?.budget_hours &&
      inputs?.rate &&
      (inputs?.budget_hours * inputs?.rate).toFixed(2),
    [inputs.budget_hours, inputs.rate]
  );

  useEffect(() => {
    if (defaultBillingRate) {
      setInputs({ ...inputs, rate: defaultBillingRate });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultBillingRate]);

  useEffect(() => {
    if (
      calculatedHours !== inputs.budget_hours &&
      lastUpdatedInput === "budget_amount"
    ) {
      setInputs({ ...inputs, budget_hours: calculatedHours });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculatedHours]);

  useEffect(() => {
    if (
      calculatedAmount !== inputs.budget_hours &&
      lastUpdatedInput === "budget_hours"
    ) {
      setInputs({ ...inputs, budget_amount: calculatedAmount });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculatedAmount]);

  const handleChange = debounce(
    (name, value) => {
      const innerValue = parseFloat(value?.replace(/[$,]+/g, "") || 0);

      if (name === "budget_hours" || name === "budget_amount") {
        setLastUpdatedInput(name);
      }

      if (!lastUpdatedInput && name === "rate") {
        setInputs({
          ...inputs,
          [name]: innerValue,
          budget_hours: (inputs.budget_amount / innerValue).toFixed(2)
        });
        setState({ [name]: innerValue });
      } else {
        setInputs({ ...inputs, [name]: innerValue });
        setState({ [name]: innerValue });
      }
    },
    [500]
  );

  return (
    <React.Fragment>
      <ProjectCalculatorForm
        inputs={inputs}
        showMonthlyHours={showMonthlyHours}
        onChange={handleChange}
        editing={editing}
      />
    </React.Fragment>
  );
};

ProjectBudgetCalculator.propTypes = {
  inputs: PropTypes.bool,
  editing: PropTypes.bool,
  showMonthlyHours: PropTypes.bool,
  setState: PropTypes.func,
  defaultBillingRate: PropTypes.number
};

export default ProjectBudgetCalculator;
